import { render } from "./GroupRow.vue?vue&type=template&id=2bd68d00"
import script from "./GroupRow.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupRow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Event/GroupRow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bd68d00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bd68d00', __exports__)) {
    api.reload('2bd68d00', __exports__)
  }
  
  module.hot.accept("./GroupRow.vue?vue&type=template&id=2bd68d00", () => {
    api.rerender('2bd68d00', render)
  })

}


export default __exports__